import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';
import { EquipmentItem } from './equipment-item';

export class EquipmentLibrary implements ViewModel, EquipmentItem {
  readonly friendlyTypeNameSingular = 'Equipment Library';
  readonly apiRoute: string = CONFIG.apiRoutes.equipmentLibrary;
  id: string;
  name: string;
  identifier: string;
  json() {
    return {
      id: this.id,
      name: this.name,
    };
  }

  public loadFromJson(data) {
    this.id = data.id;
    this.name = data.name;
  }
}
